module.exports = __webpack_public_path__ + "img/120.9.fe9d84ef.png";